import { render, staticRenderFns } from "./OsobaUmanjeniSatEdit.vue?vue&type=template&id=4976abc2&scoped=true&"
import script from "./OsobaUmanjeniSatEdit.vue?vue&type=script&lang=js&"
export * from "./OsobaUmanjeniSatEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4976abc2",
  null
  
)

export default component.exports